import React from 'react'

import { iconStyles, pillStyles, textStyles } from './styles'
import { Icon, IconSize } from '@sidecar-components/atoms/Icon'
import { Sentiment } from '@sidecar-components/types'
import { PillProps, PillWeight } from './Pill.types'

/**
 * Pills highlight an item's status or attribute.
 *
 * @param {string} className Adds more classes to the pill for specific use
 *   cases
 * @param {string} testId Adds a data-testid param to the pill for Heap tracking
 *   and automated testing.
 * @param {string} icon Name of optional icon
 * @param {Sentiment} sentiment Color of pill
 * @param {string} text Text to show in pill
 * @param {truncation} boolean Whether or not to truncate the text
 * @returns A single pill
 */
export const Pill = ({
  className = '',
  testId = '',
  icon,
  sentiment = Sentiment.DEFAULT,
  text = 'Pill',
  truncation = true,
  weight = PillWeight.DEFAULT,
}: PillProps) => {
  return (
    <span
      className={`${pillStyles(sentiment, truncation, weight)} ${className}`}
      data-testid={testId}
    >
      {!!icon && (
        <Icon
          className={`${iconStyles(sentiment, weight)} ${className}`}
          name={icon}
          size={IconSize.XS}
        />
      )}

      {/* Title is used to show the full text when the pill is truncated  */}
      <span className={textStyles(truncation)} title={text}>
        {text}
      </span>
    </span>
  )
}
